import {useRequest} from 'ahooks';
import {Service, Options, Plugin, Result} from 'ahooks/lib/useRequest/src/types';
import {notification} from 'antd';
import useCommon from './common';

const useRequestCustom = (
  service: Service<unknown, any[]>,
  options?: Options<unknown, any[]>,
  plugins?: Plugin<unknown, any[]>[]
): Result<unknown, any[]> => {
  const {t} = useCommon({
    withTranslation: ['errorCodes'],
  });

  const result = useRequest(service, {
    onError: err => {
      console.log('error custom hook', err, err?.response?.data);

      // Check if options has onError - if yes, call it and skip notification
      if (options?.onError) {
        options.onError(err);
        return;
      }

      // Disabled: Global error notifications are now opt-in via showErrorNotification option
      // To show notifications, pass { showErrorNotification: true } in options
      const showErrorNotification = (options as any)?.showErrorNotification;

      if (!showErrorNotification) {
        // Just log to console, don't show notification
        console.log('API error (notification suppressed):', err?.message || err);
        return;
      }

      const errMessage = err?.response?.data?.message;
      const errDescription = err?.response?.data?.extras?.errors;
      const errCode =
        err?.response?.data?.code ||
        err?.response?.data?.error?.code ||
        err?.response?.data?.errorCode;

      // errCode missing translation key, use default message
      if (!errCode || errCode === t(errCode)) {
        notification.error({message: t('default.title'), description: t('default.message')});
      } else {
        notification.error({message: t('default.title'), description: t(errCode)});
      }
    },
    loadingDelay: 500,
    pollingErrorRetryCount: 3,
    ...options,
  });

  // You can add custom logic here if needed

  return result;
};

export default useRequestCustom;
